<template>
  <v-navigation-drawer
    v-model="showHintSideBar"
    fixed
    temporary
    right
    hide-overlay
    light
    class="hintSideBar"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title><b>Helpful Hints</b></v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click="showHintSideBar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense class="listContainer">
      <v-list-item
        v-for="hintsList in componentHints"
        :key="hintsList.Component.Fems"
        class="componentList"
      >
        <v-list-item-content class="componentContent pb-0">
          <v-list-item-title>{{ hintsList.Component.DisplayName }}</v-list-item-title>
        </v-list-item-content>
        <v-list dense>
          <v-list-item
            v-for="hint in hintsList.hints"
            :key="'componentHint' + hint.HintID"
            link
            @mouseover.stop.prevent="highlightComponent(hint.TargetElementClass)"
            @mouseleave.stop.prevent="removeComponentHighlight(hint.TargetElementClass)"
          >
            <v-list-item-icon class="hintIcon">
              <v-icon>{{ getIcon(hint.Media) }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content
              @click="handleHintClick(hint)"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-list-item-title v-on="on">{{ hint.Title }}</v-list-item-title>
                </template>
                <span>{{ hint.Title }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item>
      <v-list-item class="componentList supportDocs v-list-item--link">
        <v-list-item-content class="componentContent pb-0" @click="openSupportDocs()">
          <v-list-item-title>Can't find what you're looking for?</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <ModalWrapper
      v-model="showSupportModal"
      femsName="support-docs"
      femsVersion="v1"
      :aEvents="supportDocsAEvents"
      :modalDataSet="supportDocsModalDataSet"
      :fromBottom="true"
    />
  </v-navigation-drawer>
</template>

<script>
import ModalWrapper from 'component-modal-wrapper'
export default {
  name: 'header_hintSideBar',
  components: {
    ModalWrapper,
  },
  data() {
    return {
      showHintSideBar: false,
      showSupportModal: false,
      supportDocsAEvents: [
        {
          eventName: 'cancelSupportDocsModal',
          callback: () => {
            this.showSupportModal = false
          },
        },
      ],
      supportDocsModalDataSet: {
          isPersistent: true,
          noClickAnimation: true,
          isFullscreen: true,
          isModal: true,
      },
      componentHints: [],
    }
  },
  beforeMount() {
    this.guibus_subscribe('toggle:hintSideBar', this.toggleSideBar)
    this.guibus_subscribe('addToQueue:componentHints', this.addComponentHints)
    this.guibus_subscribe('destroyed:fems', this.filterHints)
  },
  methods: {
    handleHintClick(hint) {
      this.guibus_publish('show:adacadoHint', hint)
      this.showHintSideBar = false
      this.guibus_publish('dispatch:beacon', {
        eventId: `header-help_option_hint_${hint.HintID}-click`,
      })
    },
    highlightComponent(targetElementClass) {
      const highlightElement = document.getElementsByClassName(targetElementClass)[0]
      if (!highlightElement) return
      const highlightBox = highlightElement.getBoundingClientRect()
      const highlighter = document.createElement('div')
      highlighter.style.position = 'absolute'
      highlighter.style.top = highlightBox.top - 5 + 'px'
      highlighter.style.left = highlightBox.left - 5 + 'px'
      highlighter.style.width = highlightBox.width + 10 + 'px'
      highlighter.style.height = highlightBox.height + 10 + 'px'
      highlighter.style.zIndex = '1000'
      highlighter.style.backgroundColor = '#FFD70020'
      // add class name with target element class
      highlighter.className = targetElementClass + '_highlighter'
      document.body.appendChild(highlighter)
    },
    removeComponentHighlight(targetElementClass) {
      const highlightedElements = document.getElementsByClassName(
        targetElementClass + '_highlighter'
      )
      if (!highlightedElements.length) return
      for (let i = highlightedElements.length - 1; i >= 0; i--) {
        highlightedElements[i].remove()
      }
    },
    openSupportDocs() {
      this.guibus_publish('dispatch:beacon', {
        eventId: `header-help_cant_find_option-click`,
      })
      this.showSupportModal = true
    },
    filterHints(fems) {
      this.componentHints = this.componentHints.filter(h => h.Component.Fems !== fems)
    },
    toggleSideBar() {
      this.showHintSideBar = !this.showHintSideBar
    },
    addComponentHints(hints) {
      let deDupedHints = []
      hints.forEach(hint => {
        if (!deDupedHints.find(dh => dh.Title === hint.Title)) {
          deDupedHints.push(hint)
        }
      })
      // do not add hints again if hints for that component have already been added
      if (!this.componentHints.find(ch => ch?.Component.Fems === deDupedHints[0]?.Component.Fems)) {
        this.componentHints.push({
          Component: deDupedHints[0].Component,
          hints: deDupedHints.sort(_compareTitle),
        })
        this.componentHints.sort(_compareDisplayName)
      }
    },
    getIcon(hintMedia) {
      if (!hintMedia) return 'mdi-card-text'
      switch (hintMedia.Type) {
        case 'video':
          return 'mdi-video'
        case 'image':
          return 'mdi-image'
        default:
          return 'mdi-card-text'
      }
    },
  },
  beforeDestroy() {
    this.guibus_unsubscribe('toggle:hintSideBar', this.toggleSideBar)
    this.guibus_unsubscribe('addToQueue:componentHints', this.addComponentHints)
    this.guibus_unsubscribe('destroyed:fems', this.filterHints)
  },
}

function _compareDisplayName(a, b) {
  if (a.Component.DisplayName < b.Component.DisplayName) {
    return -1
  }
  if (a.Component.DisplayName > b.Component.DisplayName) {
    return 1
  }
  return 0
}

function _compareTitle(a, b) {
  if (a.Title < b.Title) {
    return -1
  }
  if (a.Title > b.Title) {
    return 1
  }
  return 0
}
</script>

<style lang="scss" scoped>
.componentList {
  display: block !important;
  .componentContent {
    margin-bottom: -10px;
  }
}

.supportDocs {
  cursor: pointer;
}

.hintIcon {
  margin-right: 10px !important;
}

.hintSideBar {
  height: calc(100vh - 48px) !important;
  z-index: 1002;
  margin-top: 48px;
}

.listContainer {
  max-height: calc(100vh - 109px);
  overflow-y: auto;
}

.helpPageLink {
  position: absolute;
  bottom: 5px;
}
</style>
